import { render, staticRenderFns } from "./RelationEditorModal.vue?vue&type=template&id=1aaeed4e&"
import script from "./RelationEditorModal.vue?vue&type=script&lang=js&"
export * from "./RelationEditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports